import {dehydrate} from '@tanstack/react-query';
import {FC, PropsWithChildren} from 'react';
import {getQueryClientForHydrator} from './QueryHydrator.util';
import {QueryHydratorClient} from './QueryHydratorClient';

interface IQueryHydratorProps extends PropsWithChildren {
    keys: (number | string | object | undefined)[];
    data: unknown;
    replacePrevious?: boolean;
}

/** Server-side query hydrator to save prefetched SSR data for useQuery */
export const QueryHydrator: FC<IQueryHydratorProps> = ({
    keys,
    data,
    replacePrevious,
    children,
}) => {
    const queryClient = getQueryClientForHydrator();
    queryClient.setQueryData(keys, data);
    const dehydratedState = dehydrate(queryClient);

    return (
        <QueryHydratorClient
            state={dehydratedState}
            replacePrevious={replacePrevious}
        >
            {children}
        </QueryHydratorClient>
    );
};
